
<template>
  <v-container fluid>
    <div class>
      基本資料
    </div>
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <v-form ref="form">
          <v-text-field
            v-model="loginInfo.cust_id"
            readonly
            disabled
            :counter="10"
            label="客戶ID"
            required
          />
          <v-text-field
            v-model="loginInfo.uid"
            readonly
            disabled
            label="登入ID"
            required
          />
          <v-text-field
            v-model="password"
            :rules="requireRules"
            type="password"
            label="登入密碼"
            required
          />
          <v-text-field
            v-model="chkpw"
            :rules="errorMessage.chkpwRules"
            type="password"
            label="再次確認密碼"
            required
          />
          <v-text-field
            v-model="createtime"
            disabled
            readonly
            label="建檔日期"
            required
          />

          <v-btn
            color="primary"
            @click="submit"
          >
            送出
          </v-btn>
        </v-form>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbar"
      top
      :color="snackbarcolor"
      multi-line="multi-line"
      timeout="2000"
    >
      {{ text }}
      <template #action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Cookies from "js-cookie";
var md5 = require("md5");

export default {
  components: {},
  data: () => ({
    snackbar: "",
    snackbarcolor: "",
    chkpw: "",
    text: "",
    password: "",
    createtime: "2019-08-15 20:56:29",
    requireRules: [(v) => !!v || " required"],
  }),
  computed: {
    host() {
      return this.$store.state.host;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    errorMessage() {
      return {
        chkpwRules: [
          (v) => !!v || " is required",
          (v) => v === this.password || "密碼不符合",
        ],
      };
    },
  },
  mounted: function () {
    Cookies.set("url", "/Account");

    let nform = {
      cust_id: this.loginInfo.cust_id,
    };
    let that = this;
    this.$store
      .dispatch("exec_cust_uid_005", nform)
      .then((res) => {
        res.map(function (item) {
          if (item.uid == that.loginInfo.uid) {
            that.createtime = item.create_dat;
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        let psw = md5(this.password);

        let nform = {
          cust_id: this.loginInfo.cust_id,
          uid: this.loginInfo.uid,
          psw: psw,
        };

        let that = this;
        this.$store
          .dispatch("exec_cust_uid_004", nform)
          .then((res) => {
            res = res.trim();
            if (res == "done") {
              that.text = "success";
              that.snackbarcolor = "success";
            } else {
              that.text = "fail";
              that.snackbarcolor = "red";
            }
            that.snackbar = true;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>

<style>
</style>